import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'iv-resi-create-invoice',
  templateUrl: './resi-create-invoice.component.html',
  styleUrls: ['./resi-create-invoice.component.scss']
})
export class ResiCreateInvoiceComponent implements OnInit {

  @Input() formData;
  createInvoiceModalForm : UntypedFormGroup
  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm() {
    let params = {};
    this.formData.forEach(form => {
      params[form.id] = [form.selectedValues || '', Validators.required];
    });
    this.createInvoiceModalForm = this.fb.group(params);
    // console.log(this.createInvoiceModalForm);
  }

}
